import { Component, OnInit } from '@angular/core';
import * as Rx from 'rxjs';
import { MagliveApiClient } from "src/lib/api-client/maglive-api-client";
import { tap } from "rxjs/operators";
import { MagazineMeta } from "src/lib/entity/magazine";

@Component({
  selector: 'maglive-admin-suspend-magazine',
  styleUrls: ['../../../pages/admin/startbootstrap-sb-admin-gh-pages/src/scss/styles.scss', './suspend-magazine.component.scss'],
  templateUrl: './suspend-magazine.component.html'
})
export class SuspendMagazineComponent implements OnInit {

  private _suspendedMagazines$: Rx.Observable<MagazineMeta[] | "NOT_AUTHORIZED">;
  suspendMagazineId: string;

  get suspendedMagazines$(): Rx.Observable<MagazineMeta[] | "NOT_AUTHORIZED"> {
    return this._suspendedMagazines$;
  }

  ngOnInit(): void {
    this.reloadSuspendedMagazine();
  }

  private reloadSuspendedMagazine() {
    this._suspendedMagazines$ = MagliveApiClient.listSuspendedMagazine();
  }

  addSuspendedMagazine() {
    if (this.suspendMagazineId === null || this.suspendMagazineId === "" || isNaN(parseInt(this.suspendMagazineId, 10))) {
      console.error(this.suspendMagazineId);
      return; // TODO show error
    }
    MagliveApiClient.addSuspendMagazine(parseInt(this.suspendMagazineId, 10)).pipe(
      tap(_ => this.suspendMagazineId = "")
    ).subscribe(() => setTimeout(() => this.reloadSuspendedMagazine(), 500));
  }

  removeSuspendedMagazine(magazineId: number) {
    MagliveApiClient.removeSuspendMagazine(magazineId).subscribe(() => setTimeout(() => this.reloadSuspendedMagazine(), 500))
  }
}
